/**
 * Faturas geradas pelo atalho "Receber pagamento" no frete (PR #42) recebem
 * número no formato `F-{code}`. O backend constraint
 * `@@unique([tenantId, invoiceNumber])` impede que um número manual com o
 * mesmo padrão seja criado, então o teste de prefixo é confiável.
 */
const QUICK_RECEIPT_PATTERN = /^F-\d+$/

export function isQuickReceiptInvoice(invoiceNumber: string | null | undefined): boolean {
  return !!invoiceNumber && QUICK_RECEIPT_PATTERN.test(invoiceNumber)
}
